import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { groupObservationsByType } from "~/modules/project/screens/ProjectReviewVisitV2Screen/utils/groupObservationsByType";

import { FinalReportPlannerVisitProjectFragment } from "../../../fragment.generated";
import FinalReportObservationTableItem from "../FinalReportObservationTableItem";
import {
    FinalReportObservationsTableItemFragment,
    PreciseLocationFormFragment,
} from "../FinalReportObservationTableItem/fragment.generated";

type Props = {
    observations: FinalReportObservationsTableItemFragment[];
    preciseLocationForm: PreciseLocationFormFragment;
    project: FinalReportPlannerVisitProjectFragment;
};

export default function FinalReportObservationTable({ observations, preciseLocationForm, project }: Props) {
    const { t } = useTranslation("project");

    const groupedObservations = useMemo(() => groupObservationsByType(observations), [observations]);

    return (
        <>
            {observations.length > 0 && (
                <Table sx={{ tableLayout: "fixed" }}>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <Typography variant="subtitle2">
                                    {t("projectReviewVisitV2.finalReportRoute.finalReportObservationTable.labelType")}
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="subtitle2">
                                    {t("projectReviewVisitV2.finalReportRoute.finalReportObservationTable.labelWhere")}
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="subtitle2">
                                    {t(
                                        "projectReviewVisitV2.finalReportRoute.finalReportObservationTable.labelAddress",
                                    )}
                                </Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {groupedObservations.map(observationGroup => (
                            <FinalReportObservationTableItem
                                key={observationGroup.id}
                                observationGroup={observationGroup}
                                preciseLocationForm={preciseLocationForm}
                                project={project}
                            />
                        ))}
                    </TableBody>
                </Table>
            )}
        </>
    );
}
